import { Container, Row, Col, Nav, Tab } from "react-bootstrap";

function Docs() {
  return (
    <div className="docs">
      <Tab.Container defaultActiveKey="introduction">
        <Row>
          <Col md={3} className="bg-light p-3 border-end">
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="introduction">SAT docs</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="release-notes">Release notes</Nav.Link>
                <Nav className="flex-column ms-3">
                  <Nav.Item>
                    <Nav.Link eventKey="release-march-2025">
                      Maart 2025
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="release-may-2025">Mei 2025</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="release-february-2026">Februari 2026</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="release-march-2026">Maart 2026</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="release-april-2026">April 2026</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="release-may-2026">Mei 2026</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Nav.Item>
            </Nav>
          </Col>

          <Col md={9}>
            <Tab.Content>
              <Tab.Pane eventKey="introduction">
                <h2>SAT docs</h2>
                <p>
                  Welkom op de documentatie van SAT. Op deze pagina kan je een
                  antwoord vinden op de meest voorkomende vragen. Daarnaast vind
                  je er de release notes terug van de webapplicatie (release
                  notes vanaf maart 2025).
                </p>
              </Tab.Pane>
              <Tab.Pane eventKey="release-notes">
                <h2>Release notes</h2>
                <p>
                  In deze sectie worden de zogenaamde release notes toegevoegd.
                  Release notes bevatten informatie over de wijzigingen,
                  verbeteringen en nieuwe functies in elke update van SAT. Ze
                  helpen je om op de hoogte te blijven van recente
                  ontwikkelingen en eventuele aanpassingen in de webapplicatie.
                </p>
              </Tab.Pane>
              <Tab.Pane eventKey="release-march-2025">
                <h2>Release Notes - Maart 2025</h2>
                <p>Dit zijn de nieuwigheden in de release(s) van maart 2025:</p>
                <ul>
                  <li>
                    <a href="#250301">Vernieuwde navigatie</a>
                  </li>
                  <li>
                    <a href="#250302">Documentatie</a>
                  </li>
                  <li>
                    <a href="#250303">Snapshots</a>
                  </li>
                  <li>
                    <a href="#collega-inactive">Docenten inactief maken</a>
                  </li>
                  <li>
                    <a href="#250304">Plannen per phase</a>
                  </li>
                  <li>
                    <a href="#250305">Downloaden prestatieregeling als PDF</a>
                  </li>
                  <li>
                    <a href="#250306">Visuele indicaties in lijst docenten</a>
                  </li>
                  <li>
                    <a href="#250307">U-nummer in export docenten</a>
                  </li>
                  <li>
                    <a href="#250308">Pair teaching</a>
                  </li>
                </ul>

                <h3 className="mt-4" id="250301">
                  Vernieuwde navigatie
                </h3>
                <p>
                  De navigatie van SAT is aangepast om gemakkelijker het
                  overzicht te kunnen bewaren. Instellingen waar je normaal
                  gesproken minder frequent tot zelden mee bezig bent (zoals de
                  algemene parameters), zijn &apos;verhuisd&apos; van
                  &apos;Beheer&apos; naar het tandwieltje (
                  <i className="fas fa-cog" />
                  ), waar eerder enkel &apos;Mijn instellingen&apos; onder te
                  vinden was.
                </p>
                <p>
                  De navigatie ziet er nu als volgt uit, bij het klikken op{" "}
                  <i className="fas fa-cog" />:
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Navigation.png"
                  className="img-fluid"
                  alt="Vernieuwde navigatie"
                />

                <h3 className="mt-4" id="250302">
                  Documentatie
                </h3>
                <p>
                  Ook de pagina die je op dit moment leest, is splinternieuw. In
                  de documentatie zullen onder meer de release notes verschijnen
                  (in plaats van in het SAT Teamskanaal). Je kan de documentatie
                  bereiken door op het icoontje van het boek (
                  <i className="fas fa-book" />) te klikken helemaal rechts in
                  de navigatie.
                </p>

                <h3 className="mt-4" id="250303">
                  Snapshots
                </h3>
                <h4>Aanmaken van snapshots</h4>
                <p>
                  Snapshots zijn terug van weggeweest! In het verleden werden
                  snapshot al gebruikt om historische data te bekijken. De
                  grote lijnen zijn hetzelfde gebleven maar er zijn lichte
                  wijzigingen gebeurd om extra functionaliteiten op te vangen.
                </p>
                <p>
                  Snapshots worden in deze nieuwe versie <b>niet</b> meer automatisch
                  aangemaakt. Het automatisch aanmaken van snapshots zorgde vroeger voor een ongebruiksvriendelijke en zeer
                  lange lijst waar niemand wijzer uit werd. In deze iteratie zal
                  je zelf je snapshots moeten maken door op het camera icoontje
                  (<i className="fas fa-camera" />) naast de snapshotlijst
                  bovenaan in de menubalk te klikken. Dit start het proces om
                  een nieuwe snapshot te creëren. Eenmaal dit proces verwerkt
                  is (duurt gemiddeld minder dan 10 seconden), zal je een melding
                  krijgen dat de snapshot is aangemaakt en zal deze ook in de
                  dropdownlijst verschijnen.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Snapshots_Confirm_and_menu.png"
                  className="img-fluid"
                  alt="Bevestiging van creatie en menubalk"
                  title="Bevestiging van creatie en menubalk met lijst en icoon"
                />
                <p>
                  De benaming van de snapshots is opgebouwd uit het jaar, de
                  maand, de dag, het uur, de minuut en de seconde (in UTC)
                  waarop deze aangemaakt is.
                </p>
                <h4>Inladen van snapshots</h4>
                <p>
                  Het inladen van snapshots werkt nog steeds zoals voorheen,
                  maar hier nog even de belangrijkste zaken op een rij:{" "}
                </p>
                <ul>
                  <li>
                    Je laadt de snapshot in door hem bovenaan in de dropdown menu
                    in de navigatiebalk te selecteren.
                  </li>
                  <li>
                    Je krijgt daarna enkel data te zien die in deze snapshot
                    bewaard is.
                  </li>
                  <li>
                    Je kan enkel data bekijken, data aanpassen is niet mogelijk!
                  </li>
                </ul>
                <h4>Snapshots beheren</h4>
                <p>
                  Je kan vanaf nu ook de snapshots beheren! In de instellingen
                  menu, vind je de optie "Snapshots" terug.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Snapshots_Manage.png"
                  className="img-fluid"
                  alt="Instellingen menu met snapshots onderaan"
                  title="Instellingen menu met snapshots onderaan"
                />
                <p>
                  Op deze pagina kan je snapshots (de)publiceren voor docenten
                  of volledig verwijderen. Om te publiceren klik je het vinkje
                  aan bij de respectievelijke snapshot, om te verwijderen klik
                  je op de rode knop met de vuilbak.
                </p>
                <p>
                  <b>
                    LET OP: momenteel is hier nog geen extra confirmation check.
                    Let dus goed op voor je een snapshot verwijdert gezien deze
                    voor altijd weg is!
                  </b>
                </p>

                <img
                  src="/images/docs/2025-03/2025-03_Snapshots_Manage_table.png"
                  className="img-fluid"
                  alt="Snapshot beheer tabel"
                  title="Snapshot beheer tabel"
                />
                <h4>Voor docenten</h4>
                <p>
                  Dit nieuwe systeem kan meerdere snapshots publiceren, waardoor
                  het vanaf nu ook mogelijk is voor docenten om hun vorige
                  prestatieregelingen opnieuw te bekijken (startend bij
                  2024-2025).
                </p>
                <p>
                  {" "}
                  Docenten krijgen dezelfde dropdown in hun menubalk te zien,
                  maar zullen enkel kunnen kiezen uit een lijst van
                  gepubliceerde snapshots, zij hebben <b>geen</b> toegang tot de
                  live omgeving en/of niet-gepubliceerde snapshots
                </p>

                <h3 id="collega-inactive" className="mt-4">
                  Docenten inactief maken
                </h3>
                <p>
                  Stel dat er een docent is die het volgende academiejaar
                  afwezig zal zijn, bijvoorbeeld wegens langdurige ziekte, en
                  die je zeker niet wilt inplannen in SAT, dan is het nu
                  mogelijk om die docent op verschillende plekken in de
                  applicatie automatisch uit te filteren. Dat wordt mogelijk
                  door bij de instellingen van een docent het vinkje
                  &apos;Inactief (verborgen in applicatie)&apos; aan te vinken
                  en de wijziging op te slaan.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Collega_inactive_checkbox.png"
                  className="img-fluid"
                  alt="Collega inactief maken"
                />
                <p>
                  Overal in SAT wordt de docent nu weggefilterd. De enige twee
                  uitzonderingen zijn de overzichtslijst van docenten (zodat je
                  de docent terug actief kan maken) en op de pagina &apos;Mijn
                  prestatieregeling&apos;.
                </p>

                <h3 className="mt-4" id="250304">
                  Plannen per fase
                </h3>
                <p>
                  Tot nu toe was het in SAT mogelijk om meerdere fasen te
                  koppelen aan een OLA, maar een docent plannen voor een
                  specifieke fase kon tot dusver nog niet.
                </p>
                <p>
                  Met deze nieuwe functionaliteit kan je er voor kiezen om
                  docenten op een specifieke fase te plannen, waarbij het ook
                  mogelijk wordt om per fase verschillende contacturen in te
                  geven onder andere.
                </p>
                <p>
                  Bij het aanmaken of aanpassen van een OLA (binnen een OPO)
                  dien je het vinkje &apos;Plan per fase&apos; aan te vinken.
                  Duid vervolgens in de lijst van fasen de fasen aan waarin het
                  OLA ingericht wordt.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Plan_per_phase_choose-phases.png"
                  className="img-fluid"
                  alt="Plan per fase - kies fasen"
                />
                <p>
                  Vervolgens verschijnen de gekozen fasen en kan je per fase
                  afwijkingen ten opzichte van het gewone OLA ingeven
                  (bijvoorbeeld een andere z-code, andere contacturen,
                  enzovoort). Denk er aan je aanpassingen op te slaan.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Plan_per_phase_overrides.png"
                  className="img-fluid"
                  alt="Plan per fase - geef afwijkingen in"
                />
                <p>
                  Na het aanmaken of aanpassen van je OLA en de daarbij horende
                  fasen, kan je naar de pagina &apos;OPO-toewijzingen&apos; gaan
                  om docenten toe te wijzen.
                </p>
                <p>
                  Je zal merken dat de blokken die SAT voorziet om toe te wijzen
                  enerzijds de naam van de fase bevatten en anderzijds de
                  achtergrondkleur van de fase hebben gekregen.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Plan_per_phase_empty_assignments.png"
                  className="img-fluid"
                  alt="Plan per fase - lege toewijzingen"
                />
                <p>
                  Wanneer we in het voorbeeld hierboven klikken op een oranje
                  blokje voor de fase &apos;2CCS&apos; en vervolgens een docent
                  toekennen, dan zal deze docent aan deze fase gekoppeld worden
                  voor dit OLA. Visueel geeft dat het volgende resultaat:
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Plan_per_phase_first_assignment.png"
                  className="img-fluid"
                  alt="Plan per fase - eerste toewijzing"
                />
                <p>
                  Voor OLA&apos;s waarbij &apos;Plan per fase&apos; is
                  aangevinkt, zal de docent in zijn prestatieregeling niet
                  alleen het vak en zijn/haar collega&apos;s te zien krijgen,
                  maar ook welke collega&apos;s lesgeven aan welke fase en aan
                  welke fase hij/zij zelf les moet geven. In het voorbeeld
                  hieronder werd Brent Pulmans twee keer ingepland (één keer op
                  2IOT, een keer op 2CCS) en werd Jitse Beyens één keer
                  ingepland (op 2CCS).
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Plan_per_phase_performance_scheme.png"
                  className="img-fluid"
                  alt="Plan per fase - prestatieregeling docent"
                />
                <p>
                  Als je tijdens het plannen snel info wilt bekijken over het
                  OLA dat je aan het inplannen bent, dan kan je op de pagina
                  &apos;OPO-toewijzingen&apos; klikken op de naam van het OLA.
                  Er zal zich een scherm openen met meer info.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Plan_per_phase_OLA_name_link.png"
                  className="img-fluid"
                  alt="Klik op naam OLA voor meer info"
                />
                <p>
                  In het scherm dat zich opent zie je bovenaan de informatie van
                  het hoofd-OLA. In de delen eronder zie je info over de fasen.
                  Afwijkingen ten opzichte van het hoofd-OLA worden in het rood
                  getoond.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Plan_per_phase_OLA_info.png"
                  className="img-fluid"
                  alt="OLA info"
                />

                <h3 className="mt-4" id="250305">
                  Download prestatieregeling als PDF
                </h3>
                <p>
                  Op de pagina &apos;Mijn prestatieregeling&apos; kan je vanaf
                  nu de getoonde prestatieregeling opslaan als PDF door middel
                  van de knop &apos;Download als PDF&apos; rechts bovenaan het
                  scherm.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Download_performance_scheme_as_PDF.png"
                  className="img-fluid"
                  alt="Download prestatieregeling als PDF"
                />

                <h3 className="mt-4" id="250306">
                  Visuele indicaties in lijst docenten
                </h3>
                <p>
                  In de lijst met docenten werden extra visuele indicaties
                  toegevoegd om snel te kunnen zien welke docenten inactief zijn
                  (<a href="#collega-inactive">zie hierboven</a>), wie
                  bewerkrechten heeft in SAT, enzovoort. Zie je even door het
                  bos de bomen niet meer? Rechtsboven kan je een legende van de
                  gebruikte symbolen terugvinden door op het vraagteken te
                  klikken.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Legend_collegas_icons.png"
                  className="img-fluid"
                  alt="Download prestatieregeling als PDF"
                />
                <h3 className="mt-4" id="250307">
                  U-nummer in export docenten
                </h3>
                <p>
                  In de Excel-export van docenten werd een kolom toegevoegd waarin het u-nummer van de docent in kwestie getoond wordt.
                </p>
                <h3 className="mt-4" id="250308">
                  Pair teaching
                </h3>
                <p>
                  Om pair teaching mogelijk te maken zonder manueel het aantal klassen van iedere fase aan te moeten passen, is er een nieuw veld genaamd 'Docenten per klas' toegevoegd op OLA-niveau. Binnen de logica van '<a href="#250304">Plannen per fase</a>' kan hier ook op niveau van de OLA-fase van afgeweken worden indien gewenst. De standaardwaarde voor 'Docenten per klas' is 1.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Set_teachers_per_class_on_OLA.png"
                  className="img-fluid"
                  alt="Docenten per klas instellen op OLA"
                />
                <p>
                  In de toewijzingen zal het aantal vakjes voor toewijzingen verhoogd worden op basis van het aantal docenten per klas. In het voorbeeld hieronder is te zien dat voor de fase 2CCS er 2 klassen zijn met elk 2 docenten.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Teachers_per_class_in_assignments.png"
                  className="img-fluid"
                  alt="Docenten per klas in toewijzingen"
                />
                <p>
                  Wanneer geklikt wordt op de naam van het OLA, dan zal deze info ook hier verschijnen. Bij afwijkingen op de OLA-fase wordt het aantal docenten per klas in het rood getoond, zoals hieronder te zien is voor de fase 2CCS.
                </p>
                <img
                  src="/images/docs/2025-03/2025-03_Teachers_per_class_override.png"
                  className="img-fluid"
                  alt="Docenten per klas in info-scherm OLA"
                />
                <p>
                  <span className="text-danger fw-bold">Momenteel worden de percentages bij pair teaching nog berekend zoals voor normale toewijzingen. In een volgende release van SAT zal in de VTE-berekening ook rekening gehouden worden met pair teaching (bvb. 2 docenten per klas betekent slechts de helft van het normale percentage).</span>
                </p>
              </Tab.Pane>
              <Tab.Pane eventKey="release-may-2025">
                <h2>Release Notes - Mei 2025</h2>
                <p>Dit zijn de nieuwigheden in de release(s) van mei 2025:</p>
                <ul>
                  <li>
                    <a href="#250300">VTE-berekening naar back-end</a>
                  </li>
                  <li>
                    <a href="#250501">Vernieuwde export voor planners</a>
                  </li>
                  <li>
                    <a href="#250505">Z-code verwijderd uit &apos;Mijn prestatieregeling&apos;</a>
                  </li>
                  <li>
                    <a href="#250507">Visuele indicatie pair teaching</a>
                  </li>
                  <li>
                    <a href="#250508">Tooltip in &apos;Personal view&apos;</a>
                  </li>
                  <li>
                    <a href="#250511">Percentage in unit</a>
                  </li>
                  <li>
                    <a href="#250502">Bug fix: klassen per fase</a>
                  </li>
                  <li>
                    <a href="#250503">Bug fix: opslaan taaktoewijzingen</a>
                  </li>
                  <li>
                    <a href="#250504">Bug fix: aanpassing contacturen Q4 bij &apos;plan per fase&apos;</a>
                  </li>
                  <li>
                    <a href="#250506">Bug fix: verwijdering/aanpassing foutieve toewijzing</a>
                  </li>
                  <li>
                    <a href="#250509">Bug fix: aanpassing toewijzing stage</a>
                  </li>
                  <li>
                    <a href="#250510">Bug fix: percentage voor collega over pagina&apos;s heen</a>
                  </li>
                </ul>

                <h3 className="mt-4" id="250500">
                  VTE-berekening naar back-end
                </h3>
                <p>
                  De afgelopen periode is er hard gewerkt aan een herwerking van de VTE-berekening. Deze werd tot nu toe berekend in de front-end, met andere woorden: je eigen laptop deed al het denkwerk. Dit kon tot heel wat traagheid leiden. Voor alle pagina&apos;s werd de berekening uit de front-end gehaald en overgebouwd naar de back-end. Het zware denkwerk wordt nu dus uitgevoerd door de server, wat voor een verbetering in snelheid zou moeten zorgen. Daarnaast moet er ook minder data over het netwerk gestuurd worden, wat op vlak van security een significante verbetering is.
                </p>
                <p>
                  Een belangrijk gevolg van deze herwerking is dat de werking voor de pagina&apos;s &apos;OPO-toewijzingen&apos;, &apos;Personal view&apos; en &apos;Taak-toewijzingen&apos; veranderd is. Hier moet je nu niet langer op &apos;Opslaan&apos; klikken, iedere aanpassing die je maakt wordt per direct naar de databank gestuurd.
                </p>
                <p>Een ander gevolg van de herwerking is dat de percentages die je nu bij de &apos;OPO-toewijzingen&apos; ziet staan ook daadwerkelijk de juiste percentages zijn. Voorheen kreeg je hier een percentage te zien dat simpelweg berekend werd door het totaal voor die docent op dat vak te delen door het aantal klasgroepen.</p>
                <img
                  src="/images/docs/2025-05/2025-05_First_vs_parallel.png"
                  className="img-fluid"
                  alt="Eerste toewijzing versus parallel"
                />

                <h3 className="mt-4" id="250501">
                  Vernieuwde export voor planners
                </h3>
                <p>
                  De Excel-export die planners gebruiken om een totaaloverzicht te krijgen van welke docenten welke vakken geven, is aangepast om onder meer de nieuwe functionaliteit van &apos;plan per fase&apos; te bevatten.
                  Volgende kolommen werden toegevoegd aan de export:
                </p>
                <ul>
                  <li>Aantal klassen</li>
                  <li>Aantal docenten per klas</li>
                  <li>Plan per fase</li>
                </ul>
                <p>
                  Naast de toevoeging van kolommen werd er ook een aanpassing gedaan aan kolommen met z-codes van OPO&apos;s en OLA&apos;s. Hier wordt nu de z-code getoond voor de override (op OLA-faseniveau) indien de functionaliteit van &apos;plan per fase&apos; van toepassing is.
                </p>
                <p>
                  De export is nog steeds terug te vinden onder Beheer &gt; OPO&apos;s:
                </p>
                <img
                  src="/images/docs/2025-05/2025-05_Assignment_export.png"
                  className="img-fluid"
                  alt="Export van toewijzingen"
                />

                <h3 className="mt-4" id="250505">
                  Z-code verwijderd uit &apos;Mijn prestatieregeling&apos;
                </h3>
                <p>
                  Aangezien de z-code die docenten te zien kregen op het scherm &apos;Mijn prestatieregeling&apos; niet per se correct was (omwille van de &apos;plan per fase&apos; functionaliteit), werd deze kolom verwijderd van dit scherm.
                </p>

                <h3 className="mt-4" id="250507">
                  Visuele indicatie pair teaching
                </h3>
                <p>
                  Wanneer meerdere docenten per klas ingesteld werden op OLA-niveau, dan zal in het scherm 'OPO-toewijzingen' een indicatie verschijnen om aan te geven dat er meerdere docenten per klas gepland worden.
                </p>
                <img
                  src="/images/docs/2025-05/2025-05_Multiple_teachers_per_class.png"
                  className="img-fluid"
                  alt="Meerdere docenten per klas"
                />
                <p>
                  Opgelet: deze indicatie verschijnt enkel wanneer op het OLA meerdere docenten per klas ingesteld werden, maar houdt geen rekening met eventuele overrides op fase-niveau (bij &apos;plan per fase&apos;).
                </p>
                <p>
                  Ook op het scherm &apos;Mijn prestatieregeling&apos; werd een kleine visuele indicatie toegevoegd. Deze werd tevens toegevoegd in de legende.
                </p>
                <img
                  src="/images/docs/2025-05/2025-05_Multiple_teachers_per_class_my_performance_scheme.png"
                  className="img-fluid"
                  alt="Meerdere docenten per klas in het scherm Mijn prestatieregeling"
                />

                <h3 className="mt-4" id="250508">
                  Tooltip in &apos;Personal view&apos;
                </h3>
                <p>
                  Op de pagina &apos;Personal view&apos; werden tooltips toegevoegd. Wanneer je nu met je muis over een toewijzing of taak gaat, dan zal een tooltip verschijnen met daarin de volgende data:
                </p>
                <ul>
                  <li>Fase</li>
                  <li>Contacturen</li>
                  <li>Huidig percentage</li>
                </ul>
                <p>
                  Visueel ziet dat er als volgt uit:
                </p>
                <img
                  src="/images/docs/2025-05/2025-05_Tooltip_in_personal_view.png"
                  className="img-fluid"
                  alt="Tooltip in personal view"
                />

                <h3 className="mt-4" id="250511">
                  Percentage in unit
                </h3>
                <p>
                  Het percentage in unit werd bij het aanmaken van een nieuwe collega standaard op 100 gezet tot nu toe. Dit werd gewijzigd naar 0. Ook bij het toewijzen van percentage per opleiding voor een docent komt dit nu standaard op 0 te staan in plaats van 100.
                </p>

                <h3 className="mt-4" id="250502">
                  Bug fix: klassen per fase
                </h3>
                <p>
                  Bij het toewijzen van fasen aan een OLA werd in het verleden steeds het aantal klassen getoond, waarbij dat aantal werd overgenomen van de fase of waarbij de afwijking/override werd getoond. Sinds de release van de 'plan per fase' functionaliteit werd het aantal klassen standaard als 0 getoond door een foutje in code. Die fout is nu verholpen en het aantal klassen van de fase wordt weer getoond indien er geen override is.
                </p>
                <img
                  src="/images/docs/2025-05/2025-05_Number_of_classes_in_OLA.png"
                  className="img-fluid"
                  alt="Aantal klassen per fase in een OLA"
                />

                <h3 className="mt-4" id="250503">
                  Bug fix: opslaan taaktoewijzingen
                </h3>
                <p>
                  Bij het opslaan van taaktoewijzingen werden sinds enkele weken de wijzigingen soms niet correct verwerkt. Het probleem deed zich specifiek voor op taken die één of meerdere labels (Teach, Talk, Tap) hadden.
                </p>
                <p>Taaktoewijzingen worden vanaf nu wel correct opgeslagen in de databank.</p>

                <h3 className="mt-4" id="250504">
                  Bug fix: aanpassing contacturen Q4 bij &apos;plan per fase&apos;
                </h3>
                <p>
                  Wanneer bij de functionaliteit van &apos;plan per fase&apos; de contacturen van Q4 aangepast werden voor een specifieke fase, dan sprong dit cijfer terug naar zijn originele waarde en werd Q3 ten onrechte gewijzigd. Dit probleem is in deze release verholpen.
                </p>

                <h3 className="mt-4" id="250506">
                  Bug fix: verwijdering/aanpassing foutieve toewijzing
                </h3>
                <p>
                  Wanneer bij de functionaliteit van &apos;plan per fase&apos; een aanpassing gedaan werd aan een toewijzing (bijvoorbeeld een andere docent toekennen) of wanneer een toewijzing verwijderd werd, dan kwam het helaas voor dat de foute toewijzing aangepast of verwijderd werd. In deze release zou dit probleem verholpen moeten zijn en zou steeds de juiste toewijzing gewijzigd moeten worden.
                </p>

                <h3 className="mt-4" id="250509">
                  Bug fix: aanpassing toewijzing stage
                </h3>
                <p>
                  Als gevolg van een codewijziging in de release van 20 mei, verscheen bij het klikken op een toewijzing voor een stage niet de correcte docent en het correcte aantal stages (in de plaats daarvan kreeg je de alfabetisch eerste docent te zien met 1 stage). Dit is intussen opgelost, je zou nu weer de correcte docent en aantal stages te zien moeten krijgen.
                </p>

                <h3 className="mt-4" id="250510">
                  Bug fix: percentage voor collega over pagina&apos;s heen
                </h3>
                <p>
                  Het totaalpercentage van een docent bleek niet op alle pagina&apos;s volledig hetzelfde te zijn na de release van 20 mei. Afhankelijk van de pagina die je bekeek, kon dit 0,5% of 1% verschillen. Dit werd veroorzaakt door de manier waarop afgerond werd, dat bleek niet op iedere pagina op dezelfde manier te gebeuren. In de laatste release werd dit probleem aangepakt.
                </p>
              </Tab.Pane>
              <Tab.Pane eventKey="release-february-2026">
                <h2>Release Notes - Februari 2026</h2>
                <p>Dit zijn de nieuwigheden in de release(s) van februari 2026:</p>
                <ul>
                  <li>
                    <a href="#260201">Bug fix: Foutmelding bij toevoegen van fase</a>
                  </li>
                  <li>
                    <a href="#260202">Bug fix: Foutmelding toegevoegd voor het verwijderen van een OLA-fase met toewijzingen.</a>
                  </li>
                  <li>
                    <a href="#260203">Knop toegevoegd om OPO's te klonen</a>
                  </li>
                  <li>
                    <a href="#260204">Bug fix: Verwijderen van OPO veroorzaakt foutmelding</a>
                  </li>
                  <li>
                    <a href="#260205">OPO's in bulk verwijderen</a>
                  </li>
                </ul>
                <h3 className="mt-4" id="260201">
                  Bug fix: Foutmelding bij toevoegen van fase
                </h3>
                <p>
                  Wanneer er een nieuwe fase toegevoegd werd verscheen er een foutmelding omdat de fase niet correct geladen werd tot je de pagina handmatig herlaadde omdat niet het hele fase correct geladen werd.
                  Dit probleem is nu verholpen en nieuwe fasen worden nu zonder foutmelding onmiddellijk toegevoegd.
                </p>
                <h3 className="mt-4" id="260202">
                  Bug fix: Foutmelding toegevoegd voor het verwijderen van een OLA-fase met toewijzingen.
                </h3>
                <p>
                  Wanneer je een OLA-fase verwijderde die nog toewijzingen had, toonde de UI dat dit wel degelijk luktte wat niet het geval was.
                  Er is nu een foutmelding toegevoegd die aangeeft dat je eerst de toewijzingen moet verwijderen voordat je de fase kan verwijderen en je kan de fase ook niet meer verwijderen in de UI.
                </p>
                <img
                  src="/images/docs/2026-02/2026-02_Foutmelding_Fase_verwijderen.png"
                  className="img-fluid"
                  alt="Foutmelding fase verwijderen"
                />
                <h3 className="mt-4" id="260203">
                  Knop toegevoegd om OPO's te klonen
                </h3>
                <p>
                  Een knop is toegevoegd aan de OPO's pagina waarmee je een OPO kunt klonen. Hiermee kan je snel een kopie maken van een bestaande OPO en onderliggende OLA's.
                  Er wordt een nieuw OPO aangemaakt met dezelfde naam als het origineel, maar met " - Kopie" erachter, hetzelfde gebeurt voor de onderliggende OLA's.
                  Verdere info kan handmatig aangepast worden.
                </p>
                <img
                  src="/images/docs/2026-02/2026-02_OPO_Klonen.png"
                  className="img-fluid"
                  alt="OPO klonen"
                />
                <h3 className="mt-4" id="260204">
                  Bug fix: Verwijderen van OPO veroorzaakt foutmelding
                </h3>
                <p>
                  Wanneer je een OPO verwijderde veroorzaakte dit een foutmelding doordat de onderliggende OLA's niet correct verwijderd werden.
                  Dit probleem is nu verholpen en het verwijderen van een OPO verloopt nu zonder problemen.
                </p>
                <h3 className="mt-4" id="260205">
                  OPO's in bulk verwijderen
                </h3>
                <p>
                  Het OPO beheer scherm heeft nu een selectievakje waarmee je meerdere OPO's kan selecteren en verwijderen in bulk via de knop "geselecteerde verwijderen" rechtsboven in het scherm bovenaan.
                  Het vakje om alles te selecteren houdt rekening met de aangeduide filters, dus als je een filter toepast en vervolgens op het vakje klikt, worden alleen gefilterde OPO's geselecteerd.
                </p>
                <img
                  src="/images/docs/2026-02/2026-02_Multidelete_Button.png"
                  className="img-fluid pb-4"
                  alt="OPO bulk verwijderen"
                />
                <p>
                  Bevestigingsvenster met alle aangeduide OPO's is toegevoegd om te voorkomen dat je per ongeluk OPO's verwijdert.
                </p>
                <img
                  src="/images/docs/2026-02/2026-02_Modal_Multidelete.png"
                  className="img-fluid mb-5"
                  alt="OPO bulk verwijderen"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="release-march-2026">
                <h2>Release Notes - Maart 2026</h2>
                <p>Dit zijn de nieuwigheden in de release(s) van maart 2026:</p>
                <ul>
                  <li>
                    <a href="#260206">Eigen prestatieregeling highlighted</a>
                  </li>
                  <li>
                    <a href="#260307">Excel-export</a>
                  </li>
                  <li>
                    <a href="#260309">Filter &apos;Onvolledige vakken&apos; in OPO-toewijzingen</a>
                  </li>
                  <li>
                    <a href="#260310">Filter &apos;Geen toewijzing&apos; in taak-toewijzingen</a>
                  </li>
                  <li>
                    <a href="#260308">Bug fix: Selectie docenten in personal view</a>
                  </li>
                </ul>
                <h3 className="mt-4" id="260206">
                  Eigen prestatieregeling highlighted
                </h3>
                <p>
                  Wanneer je in "mijn prestatieregeling" gaat kijken worden jezelf gehighlight in de lijst van collega's.
                  Dit maakt het makkelijker om snel je eigen gegevens terug te vinden, vooral wanneer je veel collega's binnen een vak hebt.
                </p>

                <h3 className="mt-4" id="260307">
                  Excel-export
                </h3>
                <p>
                  Op de pagina Rapportage is het nu mogelijk om een Excel-bestand te genereren met alle docenten,
                  een Excel-bestand met alle OPO's en een Excel-bestand met alle taak-toewijzingen.
                </p>
                <p>
                  Deze functionaliteit was reeds beschikbaar op andere pagina's, maar is nu centraal beschikbaar
                  gemaakt binnen de rapportagepagina.
                </p>
                <img
                  src="/images/docs/2026-03/2026-03_Excel.png"
                  className="img-fluid"
                  alt="Excel export"
                />
                <p>
                  In het rapport &apos;Genereer rapport met alle toewijzingen&apos; werd een nieuwe kolom
                  toegevoegd: <b>Override percentage</b>. Deze kolom toont het overridepercentage van elke
                  toewijzing en verschijnt telkens na de bestaande kolom &apos;Toewijzing percentage&apos;.
                  De kolom werd toegevoegd in zowel de tab <b>Vaktoewijzingen</b>
                  als in de tab <b>Taaktoewijzingen</b>.
                </p>
                <img
                  src="/images/docs/2026-03/2026-03_Excel_Override_Percentage.png"
                  className="img-fluid"
                  alt="Override percentage kolom in rapport alle toewijzingen"
                />
                <h3 className="mt-4" id="260309">
                  Filter &apos;Onvolledige vakken&apos; in OPO-toewijzingen
                </h3>
                <p>
                  Op de pagina &apos;OPO-toewijzingen&apos; is linksboven een nieuwe filterknop &apos;Onvolledige vakken&apos; toegevoegd.
                  Wanneer je op deze knop klikt, worden enkel de OPO&apos;s getoond waarvoor de toewijzingen nog niet volledig zijn.
                </p>
                <img
                  src="/images/docs/2026-03/2026-03_Filter_Onvolledige_Vakken.png"
                  className="img-fluid"
                  alt="Filter Onvolledige vakken in OPO-toewijzingen"
                />

                <h3 className="mt-4" id="260310">
                  Filter &apos;Geen toewijzing&apos; in taak-toewijzingen
                </h3>
                <p>
                  Op de pagina &apos;Taak-toewijzingen&apos; is linksboven een nieuwe filterknop &apos;Geen toewijzing&apos; toegevoegd.
                  Wanneer je op deze knop klikt, worden de taken die al een toewijzing hebben verborgen.
                </p>
                <img
                  src="/images/docs/2026-03/2026-03_Filter_Geen_Toewijzing.png"
                  className="img-fluid mb-5"
                  alt="Filter Geen toewijzing in taak-toewijzingen"
                />

                <h3 className="mt-4" id="260308">
                  Bug fix: Selectie docenten in personal view
                </h3>
                <p>
                  De selectie van docenten in de personal view wordt opnieuw correct bijgehouden.
                  Je gekozen selectie blijft nu behouden bij het herladen of verlaten van de pagina.
                </p>
              </Tab.Pane>
              <Tab.Pane eventKey="release-april-2026">
                <h2>Release Notes - April 2026</h2>
                <p>Dit zijn de nieuwigheden in de release(s) van april 2026:</p>
                <ul>
                  <li><a href="#260401">Studiepunten toegevoegd aan Opleidingen</a></li>
                  <li><a href="#260402">Type &apos;Andere&apos; voor opleidingen</a></li>
                  <li><a href="#260403">Gebruik Budgetbronnen-allocatie als Budget VTE</a></li>
                  <li><a href="#260404">Cluster opleidingen zichtbaar in Opleidingen</a></li>
                  <li><a href="#260405">Een opleiding verwijderen</a></li>
                  <li><a href="#260406">Beschikbaar VTE en totaal geplande VTE verplaatst naar contingentverdeling</a></li>
                  <li><a href="#260407">Budgetbronnen beheren</a></li>
                  <li><a href="#260408">Nieuwe pagina: Contingentverdeling</a></li>
                  <li><a href="#260409">Automatische focus op zoekveld bij toewijzen</a></li>
                  <li><a href="#260410">Popover sluiten door buiten te klikken</a></li>
                </ul>

                <h3 className="mt-4" id="260401">
                  Studiepunten toegevoegd aan opleidingen
                </h3>
                <p>
                  Op de pagina Opleidingen (Beheer &gt; Opleidingen) is een nieuwe kolom studiepunten toegevoegd. Deze kolom toont het aantal studiepunten dat aan de opleiding gekoppeld is. De waarde wordt ook gebruikt in de berekening van het budget-VTE op de pagina Contingentverdeling.
                </p>
                <img
                  src="/images/docs/2026-04/2026-04_Opleidingen_Studiepunten.png"
                  className="img-fluid mb-3"
                  alt="Kolom Studiepunten in de lijst van opleidingen"
                />
                <p>
                  Bij het aanmaken of bewerken van een opleiding kan je het aantal studiepunten invullen via het veld aantal studiepunten. Voor clusteropleidingen is dit veld uitgeschakeld en wordt de waarde automatisch berekend als de som van de studiepunten van alle gekoppelde opleidingen.
                </p>
                <p>
                  Via het veld behoort tot cluster kan je een opleiding koppelen aan een bestaande clusteropleiding. Dit veld is enkel beschikbaar voor opleidingen, niet voor clusters zelf.
                </p>
                <img
                  src="/images/docs/2026-04/2026-04_Opleidingen_Modal_Studiepunten.png"
                  className="img-fluid mb-3"
                  alt="Studiepunten en clusterkoppeling van een opleiding"
                />

                <h3 className="mt-4" id="260402">
                  Type &apos;Andere&apos; voor opleidingen
                </h3>
                <p>
                  Bij het aanmaken of bewerken van een opleiding (Beheer &gt; Opleidingen) is het type &apos;Andere&apos; toegevoegd als derde keuze naast Bachelor en Graduaat. Dit type is bedoeld voor opleidingen die niet onder een van de twee bestaande types vallen, zoals bijvoorbeeld WER, Fondsen, stuvo etc.
                </p>
                <p>
                  Opleidingen van het type &apos;Andere&apos; verschijnen als kolommen in de budgetbronnentabel op de pagina Contingentverdeling. Bachelor- en Graduaatsopleidingen verschijnen daar niet.
                </p>
                
                <h3 className="mt-4" id="260403">
                  Gebruik Budgetbronnen-allocatie als Budget VTE
                </h3>
                <p>
                  Bij het aanmaken of bewerken van een opleiding (Beheer &gt; Opleidingen) is een nieuw vinkje toegevoegd: <strong>&apos;Gebruik Budgetbronnen-allocatie als Budget VTE&apos;</strong>.
                </p>
                <p>
                  Wanneer dit vinkje aanstaat, wordt het budget-VTE voor die opleiding in de tabel &apos;Verdeling over clusters&apos; automatisch overgenomen uit de som van de ingevoerde waarden in de budgetbronnentabel.                </p>
                <p>
                  Dit vinkje wordt enkel getoond wanneer als type
                  opleiding &apos;Andere&apos; gekozen wordt. Voor Bachelor- en Graduaatsopleidingen
                  is de optie verborgen.
                </p>
                <p>
                  <strong>Opgelet:</strong> Voor de opleiding <strong>WER</strong> mag dit vinkje <strong>niet</strong> worden ingeschakeld, aangezien de middelen verdeeld zijn over de unit en de opleidingen.
                </p>

                <h3 className="mt-4" id="260404">
                  Cluster opleidingen zichtbaar in opleidingen
                </h3>
                <p>
                  Op de pagina Opleidingen worden clusteropleidingen aangeduid met een <strong>grijze achtergrond</strong> en een <strong>vetgedrukte naam</strong>. Onderliggende opleidingen worden ingesprongen weergegeven onder hun cluster. Een clusteropleiding groepeert één of meerdere individuele opleidingen en dient als overkoepelende eenheid in de contingentverdeling.
                </p>
                <p>
                  Bij het opzetten van clusteropleidingen is de volgorde van handelen belangrijk:
                </p>

                <ol>
                  <li><strong>Maak eerst de clusteropleiding aan</strong> (of open een bestaande opleiding) en vink &apos;Dit is een cluster&apos; aan. Sla op. Zolang de clusteropleiding nog niet bestaat, kan je er geen opleidingen aan koppelen.</li>
                  <li>Wil je <strong>nieuwe opleidingen</strong> aanmaken die tot dit cluster behoren? Maak ze eerst aan via de knop &apos;Nieuw&apos; en koppel ze daarna aan de clusteropleiding via het veld &apos;Behoort tot cluster&apos;.</li>
                  <li>Wil je <strong>bestaande opleidingen</strong> koppelen? Open elke opleiding via het bewerkicoon en selecteer de clusteropleiding in het veld &apos;Behoort tot cluster&apos;.</li>
                  <li>Vul ten slotte de <strong>studiepunten</strong> in per onderliggende opleiding. Voor de clusteropleiding zelf worden de studiepunten automatisch berekend als de som van de gekoppelde opleidingen.</li>
                </ol>

                <h3 className="mt-4" id="260405">
                  Een opleiding verwijderen
                </h3>
                <p>
                  Een opleiding kan enkel verwijderd worden als ze nergens meer in gebruik is. Concreet moet aan twee voorwaarden voldaan zijn:
                </p>
                <ol>
                  <li>
                    <strong>Geen onderliggende opleidingen meer.</strong> Gaat het om een clusteropleiding? Dan mogen er geen opleidingen meer aan deze cluster gekoppeld zijn. Open eerst de onderliggende opleidingen via Beheer &gt; Opleidingen, haal de cluster weg in het veld &apos;Behoort tot cluster&apos;, of verwijder de onderliggende opleidingen helemaal.
                  </li>
                  <li>
                    <strong>Geen ingevulde waarden bij budgetbronnen.</strong> Bij de contingentverdeling mogen er voor deze opleiding geen waarden (verschillend van 0 of leeg) meer ingevuld staan. Ga naar Beheer &gt; Contingentverdeling, maak de cellen voor deze opleiding leeg, klik op Opslaan en probeer dan opnieuw te verwijderen.
                  </li>
                </ol>
                <p>
                  Voldoet de opleiding niet aan deze voorwaarden, dan krijg je een foutmelding waarin staat wat er nog in de weg zit.
                </p>

                <h3 className="mt-4" id="260406">
                  Beschikbaar VTE en totaal geplande VTE verplaatst naar contingentverdeling
                </h3>
                <p>
                  De kolommen Beschikbaar VTE en totaal geplande VTE zijn verwijderd uit de pagina opleidingen en zijn voortaan uitsluitend terug te vinden op de nieuwe pagina contingentverdeling.
                </p>

                <h3 className="mt-4" id="260407">
                  Budgetbronnen beheren
                </h3>
                <p>
                  Budgetbronnen kunnen beheerd worden via Beheer &gt; Budgetbronnen. Op deze pagina zie je een overzicht van alle bestaande budgetbronnen. Je kan een budgetbron aanmaken via de knop nieuw rechtsbovenaan, een bestaande bewerken via het potloodicoon of verwijderen via het vuilbakicoon.
                </p>
                <p>
                  Een budgetbron kan enkel verwijderd worden als er bij de contingentverdeling geen ingevulde waarden (verschillend van 0 of leeg) meer voor staan. Staat er nog een waarde ingevuld, dan krijg je een foutmelding. Ga in dat geval naar Beheer &gt; Contingentverdeling, maak de cellen voor deze budgetbron leeg, klik op Opslaan en probeer dan opnieuw te verwijderen.
                </p>
                <img
                  src="/images/docs/2026-04/2026-04_Budgetbronnen_Overzicht.png"
                  className="img-fluid mb-3"
                  alt="Overzicht van de budgetbronnen pagina"
                />

                <h3 className="mt-4" id="260408">
                  Nieuwe pagina: Contingentverdeling
                </h3>
                <p>
                  Er is een nieuwe pagina toegevoegd: Contingentverdeling. Deze pagina geeft een volledig overzicht van hoe het beschikbare VTE-budget verdeeld wordt over de verschillende opleidingen en clusters. De pagina bestaat uit twee delen: de <strong>budgetbronnen tabel</strong> bovenaan en het overzicht <strong>verdeling over clusters</strong> onderaan.
                </p>
                <p>
                  Wanneer de opleiding <strong>WER</strong> of <strong>Unit</strong> niet gevonden wordt op deze pagina, verschijnt er bovenaan een waarschuwing. Het variabel deel voor opleidingen wordt dan mogelijk verkeerd berekend.
                </p>
                <p>
                  Zorg er voor dat je eerst budgetbronnen aanmaakt via Beheer &gt; Budgetbronnen voordat je naar de pagina Contingentverdeling gaat. Zonder budgetbronnen zijn er geen rijen beschikbaar in de budgetbrontabel.
                </p>

                <h4>Budgetbronnen tabel</h4>
                <p>
                  Bovenaan de pagina vind je de budgetbrontabel. De kolommen komen overeen met opleidingen van het type &apos;Andere&apos;. Via het filter bovenaan de tabel kan je bepaalde opleidingen verbergen of tonen. Per rij staat een budgetbron en per cel kan je ingeven hoeveel VTE er vanuit die bron naar die opleiding gaat. Klik op opslaan rechtsbovenaan de tabel om de ingevoerde waarden te bewaren.
                </p>
                <p>
                  <strong>Opgelet:</strong> de kolom <em>WER</em> is vereist voor de berekening van het variabel deel voor opleidingen. Maak zelf een opleiding aan met de naam <strong>WER</strong> via <strong>Beheer &gt; Opleidingen</strong> en voeg die toe als budgetbron in de tabel. Zonder deze opleiding wordt het variabel deel voor opleidingen verkeerd berekend.
                </p>
                <img
                  src="/images/docs/2026-04/2026-04_Contingentverdeling_Budgetbronnen.png"
                  className="img-fluid mb-3"
                  alt="Budgetbronnen tabel in de contingentverdeling"
                />

                <h4>Verdeling over clusters</h4>
                <p>
                  Onder de budgetbrontabel vind je het overzicht van de verdeling over clusters. Bovenaan wordt het variabel deel voor opleidingen getoond.
                </p>
                <p>
                  De tabel toont per opleiding de studiepunten en het berekende budget-VTE op basis van het aandeel studiepunten. Clusters worden vetgedrukt weergegeven met een grijze achtergrond, onderliggende opleidingen worden ingesprongen getoond.
                </p>
                <p>
                  Via de schakelaar <strong>Verberg gekoppelde deelopleidingen</strong> worden de opleidingen die als deelopleidingen onder een cluster hangen verborgen.
                </p>
                <img
                  src="/images/docs/2026-04/2026-04_Contingentverdeling_Clusteroverzicht.png"
                  className="img-fluid mb-3"
                  alt="Verdeling over clusters met alle opleidingen"
                />

                <h3 className="mt-4" id="260409">
                  Automatische focus op zoekveld bij toewijzen
                </h3>
                <p>
                  Wanneer je op een toewijzing klikt op de pagina&apos;s &apos;OPO-toewijzingen&apos; en &apos;Taak-toewijzingen&apos;, staat de cursor nu automatisch in het zoekveld van het venster dat verschijnt.
                </p>

                <h3 className="mt-4" id="260410">
                  Popover sluiten door buiten te klikken
                </h3>
                <p>
                  Op de pagina&apos;s &apos;OPO-toewijzingen&apos; en &apos;Taak-toewijzingen&apos; kan je de popover nu sluiten door ergens anders in het venster te klikken.
                </p>

              </Tab.Pane>
              <Tab.Pane eventKey="release-may-2026">
                <h2>Release Notes - Mei 2026</h2>
                <p>Dit zijn de nieuwigheden in de release(s) van mei 2026:</p>
                <ul>
                  <li>
                    <a href="#260501">Academiejaren als aparte pagina</a>
                  </li>
                  <li>
                    <a href="#260502">Hoewist-bevraging open of sluiten</a>
                  </li>
                  <li>
                    <a href="#260503">Drempelwaarden voorkeuren</a>
                  </li>
                  <li>
                    <a href="#260504">Hoewist-bevraging voor docenten</a>
                  </li>
                  <li>
                    <a href="#260505">Hoewist-bevragingsresultaten voor opleidingsmanagers</a>
                  </li>
                  <li>
                    <a href="#260506">Hoewist-sortering bij OPO- en taaktoewijzingen</a>
                  </li>
                  <li>
                    <a href="#260507">Fasekleur badge bij hoewist-sortering</a>
                  </li>
                  <li>
                    <a href="#260508">Taken opneembaar in voorkeurslijst docenten</a>
                  </li>
                  <li>
                    <a href="#260509">Opleiding ontkoppelen van taak geblokkeerd bij actieve toewijzingen</a>
                  </li>
                  <li>
                    <a href="#260510">Alfabetische sortering fasen in OPO-toewijzingen</a>
                  </li>
                  <li>
                    <a href="#260511">Extra info naar docent bij toewijzingen</a>
                  </li>
                  <li>
                    <a href="#260512">Vergelijken van snapshots taak beheer</a>
                  </li>
                  <li>
                    <a href="#260513">Vergelijken van snapshots taak toewijzingen</a>
                  </li>
                  <li>
                    <a href="#260514">Vergelijken van snapshots OPO beheer</a>
                  </li>
                  <li>
                    <a href="#260515">Vergelijken van snapshots OPO toewijzingen</a>
                  </li>
                </ul>
                <p>
                  <span className="text-danger fw-bold">
                    Belangrijk: vooraleer de hoewist-bevraging gebruikt kan worden, dient er eerst
                    een academiejaar aangemaakt te worden en als huidig academiejaar ingesteld te worden
                    op de pagina &apos;Academiejaren&apos; (zie hieronder).
                  </span>
                </p>

                <h3 className="mt-4" id="260501">
                  Academiejaren als aparte pagina
                </h3>
                <p>
                  Het beheer van academiejaren stond voorheen onder &apos;Parameters&apos;
                  (<i className="fas fa-cog" /> &gt; Parameters), maar werd in deze release
                  losgekoppeld en kreeg een eigen pagina. Je vindt de nieuwe pagina nu terug
                  via <i className="fas fa-cog" /> &gt; Academiejaren.
                </p>
                <p>
                  Op deze pagina kan je:
                </p>
                <ul>
                  <li>Een nieuw academiejaar toevoegen via de knop &apos;Nieuw&apos; (formaat &apos;2025-2026&apos;).</li>
                  <li>Een bestaand academiejaar aanpassen via de bewerk-knop (<i className="far fa-edit" />).</li>
                  <li>Het huidige academiejaar instellen door bij het bewerken het vinkje &apos;Instellen als huidig academiejaar&apos; aan te vinken. Het huidige academiejaar wordt in SAT gebruikt.</li>
                  <li>Een academiejaar verwijderen via de verwijder-knop (<i className="far fa-trash" />). Het academiejaar dat als huidig staat ingesteld kan niet verwijderd worden.</li>
                </ul>
                <img
                  src="/images/docs/2026-05/2026-05_Academic_Years_Page.png"
                  className="img-fluid"
                  alt="Overzicht van de academiejaren-pagina"
                />
                <p>
                  Bij het bewerken van een academiejaar kan je het als huidig instellen:
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Academic_Years_Edit.png"
                  className="img-fluid"
                  alt="Academiejaar bewerken en als huidig instellen"
                />

                <h3 className="mt-4" id="260502">Hoewist-bevraging open of sluiten</h3>
                <p>
                  Als opleidingsmanager kan je de hoewist-bevraging voor docenten openen of
                  sluiten via <i className="fas fa-cog" /> &gt; Parameters. Bovenaan de
                  pagina staat in de lijst met algemene parameters de regel
                  &apos;Hoewist-voorkeuren&apos; met de huidige status
                  (&apos;Open&apos; of &apos;Gesloten&apos;).
                </p>
                <p>
                  Via de knop &apos;Bewerk&apos; open je het bewerkscherm voor de globale
                  instellingen. Daar vind je de schakelaar &apos;Hoewist-voorkeuren open
                  voor docenten&apos;. Zet de schakelaar aan om de bevraging te openen,
                  zet hem uit om de bevraging te sluiten.
                </p>
                <p>
                  Wanneer de bevraging gesloten is, zien docenten op de pagina &apos;Mijn
                  vakvoorkeuren&apos; een melding dat het invullen van voorkeuren momenteel
                  niet beschikbaar is.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Hoewist_Voorkeuren_Toggle.png"
                  className="img-fluid"
                  alt="Schakelaar Hoewist-voorkeuren open voor docenten in de globale instellingen"
                />

                <h3 className="mt-4" id="260503">
                  Drempelwaarden voorkeuren
                </h3>
                <p>
                  Onder <i className="fas fa-cog" /> &gt; Voorkeursdrempels werd een nieuwe
                  pagina toegevoegd waarmee je kan instellen vanaf welke score een voorkeur
                  van een docent voor een vak als hoog, neutraal of laag beschouwd wordt.
                </p>
                <p>
                  Docenten geven hun voorkeur per vak op een schaal van 1 tot 10. Op basis
                  van de drempelwaarden krijgt elke score een kleur in de hoewist-resultaten
                  en bij de toewijzingen:
                </p>
                <ul>
                  <li>
                    <span className="text-success fw-bold">Hoge voorkeur</span> (groen): scores groter dan of gelijk aan de hoge drempel (standaard <strong>7</strong>).
                  </li>
                  <li>
                    <span className="text-warning fw-bold">Neutrale voorkeur</span> (geel): scores groter dan of gelijk aan de neutrale drempel (standaard <strong>4</strong>) en kleiner dan de hoge drempel.
                  </li>
                  <li>
                    <span className="text-danger fw-bold">Lage voorkeur</span> (rood): scores kleiner dan de neutrale drempel.
                  </li>
                </ul>
                <img
                  src="/images/docs/2026-05/2026-05_Preference_Thresholds.png"
                  className="img-fluid"
                  alt="Pagina drempelwaarden voorkeuren"
                />
                <p>
                  Via de knop &apos;Bewerk&apos; kan je de twee drempelwaarden aanpassen.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Preference_Thresholds_Edit.png"
                  className="img-fluid"
                  alt="Drempelwaarden voorkeuren bewerken"
                />

                <h3 className="mt-4" id="260504">
                  Hoewist-bevraging voor docenten
                </h3>
                <p>
                  Het navigatie-item &apos;Mijn prestatieregeling&apos; werd vervangen door
                  een dropdown &apos;Prestaties &amp; Voorkeuren&apos; met twee opties:
                </p>
                <ul>
                  <li><b>Mijn prestatieregeling</b> de bestaande pagina blijft ongewijzigd.</li>
                  <li><b>Mijn vakvoorkeuren</b> de nieuwe hoewist-bevraging.</li>
                </ul>
                <img
                  src="/images/docs/2026-05/2026-05_Hoewist_Navigation.png"
                  className="img-fluid"
                  alt="Vernieuwde navigatie met Prestaties &amp; Voorkeuren"
                />
                <p>
                  Op de pagina &apos;Mijn vakvoorkeuren&apos; kunnen docenten hun voorkeuren
                  doorgeven voor vakken (OLA&apos;s), fasen en taken. Bovenaan kunnen ze
                  selecteren voor welk academiejaar ze hun voorkeuren willen ingeven (zodra
                  er meerdere academiejaren beschikbaar zijn).
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Hoewist_Year_Selector.png"
                  className="img-fluid"
                  alt="Academiejaar selecteren in de hoewist-bevraging"
                />
                <p>
                  De pagina is opgedeeld in tabs: één tab per opleiding waaraan de docent
                  gekoppeld is (zie Beheer &gt; Docenten), aangevuld met een tab
                  &apos;Fasen&apos; en een tab &apos;Taken&apos;.
                </p>

                <h4>Vakvoorkeuren</h4>
                <p>
                  Per opleidingstab krijgt de docent eerst zijn eigen vakken te zien onder
                  &apos;Mijn huidige vakken&apos; en daarna de overige vakken binnen de
                  opleiding onder &apos;Overige vakken&apos;. Voor elk vak kan de docent:
                </p>
                <ul>
                  <li>Een opmerking toevoegen.</li>
                  <li>Eén van de volgende drie keuzemogelijkheden selecteren:
                    <ul>
                      <li>&quot;Voorkeursscore via schuifbalk&quot; (standaard) geef een score van <b>1 (Niet graag)</b> tot <b>10 (Heel graag)</b> in.</li>
                      <li>&quot;Sluit minder goed aan bij mijn expertise, maar ik wil me hierin bijscholen.&quot;</li>
                      <li>&quot;Sluit minder goed aan bij mijn expertise en valt buiten mijn interessegebied.&quot;</li>
                    </ul>
                  </li>
                </ul>
                <img
                  src="/images/docs/2026-05/2026-05_Hoewist_OLA_Card.png"
                  className="img-fluid"
                  alt="Voorkeur ingeven voor een vak"
                />

                <h4>Fasenvoorkeuren</h4>
                <p>
                  In de tab &apos;Fasen&apos; ziet de docent alle fasen die voorkomen binnen
                  de opleidingen waaraan hij/zij gekoppeld is. Per fase wordt het traject
                  en de campus van de fase getoond. Met
                  een schuifbalk van 1 tot 10 kan de docent aangeven hoe graag hij/zij
                  lesgeeft in die fase. Een opmerking toevoegen kan ook hier. Wie
                  geen voorkeur wil opgeven voor een fase, kan het vinkje
                  &apos;Geen voorkeur&apos; aanvinken.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Hoewist_Phase_Card.png"
                  className="img-fluid"
                  alt="Voorkeur ingeven voor een fase"
                />

                <h4>Taakvoorkeuren</h4>
                <p>
                  In de tab &apos;Taken&apos; ziet de docent eerst zijn huidige taken onder
                  &apos;Huidige taken&apos;. Per huidige taak kan hij/zij aanduiden:
                </p>
                <ul>
                  <li><b>Ja, graag</b> de docent wil deze taak voortzetten.</li>
                  <li><b>Liever niet</b> de docent wil deze taak niet langer uitvoeren.</li>
                </ul>
                <p>
                  Daaronder verschijnen onder &apos;Nieuwe taken&apos; alle andere taken
                  binnen de opleidingen van de docent waarvoor de opleidingsmanager heeft
                  ingesteld dat ze opneembaar zijn in de voorkeurslijst (<a href="#260508">zie hieronder</a>).
                  Voor deze taken kan de docent &apos;Ik heb interesse&apos; aanvinken.
                </p>
                <p>
                  Bij elke taak kan de docent ook een opmerking achterlaten. Bij elke taak wordt via een label
                  duidelijk gemaakt tot welke opleiding(en) de taak behoort.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Hoewist_Task_Card.png"
                  className="img-fluid"
                  alt="Voorkeur ingeven voor een taak"
                />
                <p>
                  Aan de onderkant van het scherm staat een vaste balk die toont of er
                  niet-opgeslagen wijzigingen zijn, met een knop om alles in één keer op te
                  slaan.
                </p>

                <h3 className="mt-4" id="260505">
                  Hoewist-bevragingsresultaten voor opleidingsmanagers
                </h3>
                <p>
                  Onder &apos;Toewijzing&apos; werd een nieuwe pagina &apos;Hoewist-resultaten&apos;
                  toegevoegd. Op deze pagina kan een opleidingsmanager per docent een
                  overzicht bekijken van de doorgegeven voorkeuren.
                </p>
                <p>
                  Bovenaan kies je een docent. Indien er voor die docent meerdere
                  hoewist-inzendingen bestaan (over meerdere academiejaren), verschijnt
                  ook een keuzemenu om het academiejaar te selecteren. Het overzicht is
                  opgedeeld in een tab per opleiding en
                  een aparte tab &apos;Taken&apos;.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Hoewist_Results.png"
                  className="img-fluid"
                  alt="Overzicht hoewist-resultaten per docent"
                />
                <p>
                  Per opleidingstab worden volgende secties getoond:
                </p>
                <ul>
                  <li>
                    <b>Huidige vakken</b>: alle vakken binnen die opleiding waaraan de
                    docent toegewezen is. Deze worden steeds getoond, ook wanneer er nog
                    geen voorkeur werd ingegeven.
                  </li>
                  <li>
                    <b>Niet-toegewezen vakken</b>: vakken waaraan de docent niet toegewezen is,
                    maar waarvoor hij/zij zelf een voorkeur heeft doorgegeven.
                  </li>
                  <li>
                    <b>Fasenvoorkeuren</b>: alle fasen die gekoppeld zijn aan de huidige
                    vakken van de docent binnen die opleiding (ook wanneer geen voorkeur
                    werd ingegeven), aangevuld met fasen waarvoor de docent een voorkeur
                    heeft ingegeven maar die niet aan zijn/haar huidige vakken gekoppeld zijn.
                  </li>
                </ul>
                <p>
                  De scores worden gekleurd op basis van de
                  ingestelde <a href="#260503">drempelwaarden</a>: groen voor hoge voorkeur,
                  geel voor neutrale en rood voor lage voorkeur. Wanneer de docent koos
                  voor &apos;extra expertise nodig&apos;, wordt in plaats van een score
                  een grijs label &apos;Wil bijscholen&apos; of &apos;Buiten interessegebied&apos;
                  getoond.
                </p>
                <p>
                  In de tab &apos;Taken&apos; worden de huidige taken steeds getoond
                  (met &apos;Ja, graag&apos; of &apos;Liever niet&apos;). Daaronder
                  verschijnen onder &apos;Nieuwe taken&apos; enkel de taken waarvoor de
                  docent interesse aangaf.
                </p>

                <h3 className="mt-4" id="260506">
                  Hoewist-sortering bij OPO- en taaktoewijzingen
                </h3>
                <p>
                  Op de pagina &apos;Mijn instellingen&apos; werd een nieuwe optie
                  toegevoegd: &apos;Hoewist-sortering&apos;, met de schakelaar
                  &apos;Docenten sorteren op Hoewist-voorkeur bij toewijzen&apos;. Deze
                  staat standaard uit.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Personal_Setup_Hoewist_Sorting.png"
                  className="img-fluid"
                  alt="Schakelaar hoewist-sortering in Mijn instellingen"
                />
                <p>
                  Wanneer deze schakelaar aan staat, wordt de lijst van docenten op de
                  pagina&apos;s &apos;OPO-toewijzingen&apos; en &apos;Taak-toewijzingen&apos;
                  gegroepeerd op basis van de hoewist-voorkeuren van het huidige
                  academiejaar.
                </p>
                <p>Bij het toewijzen van een docent aan een OLA wordt de lijst gegroepeerd in:</p>
                <ul>
                  <li><span className="text-success fw-bold">Hoge voorkeur</span> (groen)</li>
                  <li><span className="text-warning fw-bold">Neutrale voorkeur</span> (geel)</li>
                  <li><span className="text-danger fw-bold">Lage voorkeur</span> (rood)</li>
                  <li><b>Geen voorkeur</b> - docenten die expliciet aangaven geen voorkeur te hebben voor dit vak</li>
                  <li><b>Wil bijscholen</b> - docenten die aangaven dat het vak minder goed aansluit bij hun expertise, maar dat ze zich hierin willen bijscholen</li>
                  <li><b>Buiten interessegebied</b> - docenten die aangaven dat het vak buiten hun interessegebied valt</li>
                  <li><b>Geen voorkeur opgegeven</b> - docenten die niets invulden voor dit vak</li>
                </ul>
                <img
                  src="/images/docs/2026-05/2026-05_Docent_List_Sorted.png"
                  className="img-fluid"
                  alt="Docentenlijst gegroepeerd op hoewist-voorkeur"
                />
                <p>
                  Naast de vakvoorkeur wordt, indien beschikbaar, ook een badge met de
                  fasevoorkeur van de docent getoond. De achtergrondkleur van deze badge is
                  standaard de eigen kleur van de fase.
                </p>
                <h4 id="260507">Fasekleur badge (Mijn instellingen)</h4>
                <p>
                  Op de pagina &apos;Mijn instellingen&apos; is een nieuwe optie
                  &apos;Fasekleur badge&apos; toegevoegd, met de schakelaar
                  &apos;Fasekleur als achtergrond bij fasevoorkeur score&apos;. Deze
                  staat standaard aan. Zet je de schakelaar uit, dan krijgt de
                  fasevoorkeur-badge de kleur van de drempelwaarde (groen, geel of rood)
                  in plaats van de eigen kleur van de fase.
                </p>
                <p>Bij het toewijzen van een docent aan een taak wordt de lijst gegroepeerd in:</p>
                <ul>
                  <li><b>Wil deze taak graag uitvoeren</b></li>
                  <li><b>Voert deze taak liever niet uit</b></li>
                  <li><b>Geen voorkeur opgegeven</b></li>
                </ul>
                <p>
                  Wanneer een docent een opmerking heeft achtergelaten bij een vak, fase
                  of taak, verschijnt naast zijn/haar naam een tekstwolkje
                  (<i className="far fa-comment-dots" />). De volledige opmerking is
                  zichtbaar door met de muis over het icoontje te bewegen of door op de
                  pagina &apos;Hoewist-resultaten&apos; te kijken.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Docent_List_Comments.png"
                  className="img-fluid"
                  alt="Tekstwolkje bij docenten met opmerking"
                />

                <h3 className="mt-4" id="260508">
                  Taken opneembaar in voorkeurslijst docenten
                </h3>
                <p>
                  Op het bewerkscherm van een taak (Beheer &gt; Taken &gt; bewerk-knop)
                  werd een nieuw vinkje toegevoegd: &apos;Opneembaar in voorkeurslijst
                  docenten&apos;.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Task_Edit_Selectable.png"
                  className="img-fluid"
                  alt="Vinkje 'Opneembaar in voorkeurslijst docenten' op het taak-bewerkscherm"
                />
                <p>
                  Wanneer dit vinkje aanstaat, kan de taak voor docenten verschijnen in de
                  sectie &apos;Nieuwe taken&apos; van hun hoewist-bevraging. Zet je het
                  vinkje uit, dan blijft de taak gewoon bestaan en kan ze nog steeds aan
                  docenten toegewezen worden, maar verschijnt ze niet meer als optie waar
                  docenten zelf interesse voor kunnen aanduiden.
                </p>
                <h3 className="mt-4" id="260509">
                  Opleiding ontkoppelen van taak geblokkeerd bij actieve toewijzingen
                </h3>
                <p>
                  Op het bewerkscherm van een taak (Beheer &gt; Taken &gt; bewerk-knop) was het tot nu toe mogelijk om een opleiding uit te vinken ook al waren er nog taaktoewijzingen voor die combinatie. Vanaf deze release is dit niet meer mogelijk.
                </p>
                <p>
                  Opleidingen waarvoor er nog actieve taaktoewijzingen bestaan, kunnen niet uitgevinkt worden. Onder de betreffende opleiding verschijnt een melding die aangeeft dat de toewijzingen eerst verwijderd moeten worden.
                </p>
                <h3 className="mt-4" id="260510">
                  Alfabetische sortering fasen in OPO-toewijzingen
                </h3>
                <p>
                  Op de pagina &apos;OPO-toewijzingen&apos; worden fasen nu alfabetisch gesorteerd op twee plaatsen:
                </p>
                <ul>
                  <li>De fasen in het filtergedeelte aan de linkerkant worden nu alfabetisch getoond op naam.</li>
                  <li>De fase-knoppen binnen elke OLA-rij worden nu ook alfabetisch getoond op naam.</li>
                </ul>
                <h3 className="mt-4" id="260511">
                  Extra info naar docent bij toewijzingen
                </h3>
                <p>
                  Bij het bewerken van een OLA-toewijzing of taaktoewijzing is er een nieuw
                  tekstveld toegevoegd: <b>Extra info naar docent</b>. Het bestaande veld
                  &apos;Commentaar&apos; blijft ongewijzigd en is enkel zichtbaar voor de OM.
                  Het nieuwe veld is wél zichtbaar voor de docent in het scherm
                  &apos;Mijn prestatieregeling&apos;.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Toewijzing_Bewerk_Modal.png"
                  className="img-fluid"
                  alt="Bewerk modal met het veld Extra info naar docent"
                />
                <p>
                  In het scherm &apos;Mijn prestatieregeling&apos; verschijnt het bericht icoon met
                  de tekst &apos;Commentaar aanwezig&apos; bij de OLA of taak wanneer er
                  &apos;Extra info naar docent&apos; ingevuld werd. Door met de muis over de
                  volledige rij te bewegen verschijnt een popover met de volledige tekst. De
                  legende op dat scherm werd uitgebreid met dit symbool.
                </p>
                <h3 className="mt-4" id="260512">
                  Vergelijken van snapshots taak beheer
                </h3>
                <p>
                  Op de pagina beheer &gt; Taken is er een nieuwe optie toegevoegd om de huidige data 
                  te vergelijken met de data out een snapshot van het verleden. Dit doe door in de dropdown 
                  een snapshot te selecteren of handmatig de naam in te typen en vervolgens op de knop vergelijk te klikken.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Taak_Beheer_Vergelijken.png"
                  className="img-fluid"
                  alt="vergelijken van huidige data met snapshot in taak beheer"
                />
                <p>
                  Vervolgens verschijnt er dan bovenaan de pagina een venster met alle dingen die sinds de snapshot veranderd zijn. 
                  Er wordt een onderscheid gemaakt tussen nieuwe items, verwijderde items en gewijzigde items en gewijzigde items 
                  worden onderaan het venster per taak verduidelijkt.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Taak_Beheer_Diff.png"
                  className="img-fluid"
                  alt="Venster met verschillen tussen huidige data en snapshot in taak beheer"
                />
                <p>
                  Het is mogelijk om naar de rij van de aanpassingen te navigeren via de 
                  knop of gewoon rechtsreeks uit het venster de taak te bewerken via de bewerk-knop.
                  Indien het gaat over simpele aanpassingen zoals naam, percentage, categorie etc. 
                  hebt is er ook een mogelijkheid om de huidige staat van die taak terug te zetten naar 
                  de staat in de snapshot via de knop &apos;Herstel naar snapshot&apos;. 
                  of via de &apos;Herstel&apos; knop voor een specifieke aanpassing.
                </p>
                <p>
                  Verder word de staat van dit venster en de geselecteerde snapshot ook bewaard 
                  zodat je bij een volgend bezoek aan deze pagina nog steeds dezelfde vergelijking ziet 
                  zonder opnieuw een snapshot te moeten selecteren.
                  Indien je dit echter niet wil is er ook een optie voorzien in het venster om het venster te sluiten
                  en indien je te veel aanpassingen hebt uitgeklapt is hier ook een optie om alle aanpassingen in te klappen.
                </p>
                <h3 className="mt-4" id="260513">
                  Vergelijken van snapshots taak toewijzingen
                </h3>
                <p>
                  Op de pagina toewijzing &gt; taak-toewijzingen is er een nieuwe optie toegevoegd om de huidige toewijzingen 
                  te vergelijken met de data out een snapshot van het verleden. Dit doe door in de dropdown 
                  een snapshot te selecteren of handmatig de naam in te typen en vervolgens op de knop vergelijk te klikken.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Taak_Toewijzing_Vergelijken.png"
                  className="img-fluid"
                  alt="vergelijken van huidige toewijzingen met snapshot in taak toewijzingen"
                />
                <p>
                  Vervolgens verschijnt er dan bovenaan de pagina een venster met alle dingen die sinds de snapshot veranderd zijn. 
                  <br/>
                  Het is mogelijk om naar de rij van de aanpassingen te navigeren via de 
                  knop of gewoon rechtsreeks uit het venster de taak te bewerken via de bewerk-knop.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_Taak_Toewijzing_Diff.png"
                  className="img-fluid"
                  alt="Venster met verschillen tussen huidige data en snapshot in taak toewijzingen"
                />
                <p>
                  Verder word de staat van dit venster en de geselecteerde snapshot ook bewaard 
                  zodat je bij een volgend bezoek aan deze pagina nog steeds dezelfde vergelijking ziet 
                  zonder opnieuw een snapshot te moeten selecteren.
                  Indien je dit echter niet wil is er ook een optie voorzien in het venster om het venster te sluiten
                  en indien je te veel aanpassingen hebt uitgeklapt is hier ook een optie om alle aanpassingen in te klappen.
                </p>
                <h3 className="mt-4" id="260514">
                  Vergelijken van snapshots OPO beheer
                </h3>
                <p>
                  Op de pagina beheer &gt; OPO's is er een nieuwe optie toegevoegd om de huidige data 
                  te vergelijken met de data out een snapshot van het verleden. Dit doe door in de dropdown 
                  een snapshot te selecteren of handmatig de naam in te typen en vervolgens op de knop vergelijk te klikken.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_OPO_Beheer_Vergelijken.png"
                  className="img-fluid"
                  alt="vergelijken van huidige data met snapshot in opo beheer"
                />
                <p>
                  Vervolgens verschijnt er dan bovenaan de pagina een venster met alle dingen die sinds de snapshot veranderd zijn. 
                  Er wordt een onderscheid gemaakt tussen nieuwe items, verwijderde items en gewijzigde items en gewijzigde items 
                  worden onderaan het venster per taak verduidelijkt. Zowel het OPO als onderliggende OLA's worden 
                  hierbij weergegeven.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_OPO_Beheer_Diff.png"
                  className="img-fluid"
                  alt="Venster met verschillen tussen huidige data en snapshot in opo beheer"
                />
                <p>
                  Het is mogelijk om naar de rij van de aanpassingen te navigeren via de 
                  knop of gewoon rechtsreeks uit het venster de taak te bewerken via de bewerk-knop.
                </p>
                <p>
                  Verder word de staat van dit venster en de geselecteerde snapshot ook bewaard 
                  zodat je bij een volgend bezoek aan deze pagina nog steeds dezelfde vergelijking ziet 
                  zonder opnieuw een snapshot te moeten selecteren.
                  Indien je dit echter niet wil is er ook een optie voorzien in het venster om het venster te sluiten
                  en indien je te veel aanpassingen hebt uitgeklapt is hier ook een optie om alle aanpassingen in te klappen.
                </p>
                <h3 className="mt-4" id="260515">
                  Vergelijken van snapshots OPO toewijzingen
                </h3>
                <p>
                  Op de pagina toewijzing &gt; OPO-toewijzingen is er een nieuwe optie toegevoegd om de huidige toewijzingen 
                  te vergelijken met de data out een snapshot van het verleden. Dit doe door in de dropdown 
                  een snapshot te selecteren of handmatig de naam in te typen en vervolgens op de knop vergelijk te klikken.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_OPO_Toewijzing_Vergelijken.png"
                  className="img-fluid"
                  alt="vergelijken van huidige toewijzingen met snapshot in OPO toewijzingen"
                />
                <p>
                  Vervolgens verschijnt er dan bovenaan de pagina een venster met alle dingen die sinds de snapshot veranderd zijn. 
                  <br/>
                  Het is mogelijk om naar de rij van de aanpassingen te navigeren via de 
                  knop of gewoon rechtsreeks uit het venster de taak te bewerken via de bewerk-knop.
                </p>
                <img
                  src="/images/docs/2026-05/2026-05_OPO_Toewijzing_Diff.png"
                  className="img-fluid"
                  alt="Venster met verschillen tussen huidige data en snapshot in OPO toewijzingen"
                />
                <p>
                  Verder word de staat van dit venster en de geselecteerde snapshot ook bewaard 
                  zodat je bij een volgend bezoek aan deze pagina nog steeds dezelfde vergelijking ziet 
                  zonder opnieuw een snapshot te moeten selecteren.
                  Indien je dit echter niet wil is er ook een optie voorzien in het venster om het venster te sluiten
                  en indien je te veel aanpassingen hebt uitgeklapt is hier ook een optie om alle aanpassingen in te klappen.
                </p>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
}

export default Docs;
